import { render, staticRenderFns } from "./RequestHistories.vue?vue&type=template&id=2f55f65a"
import script from "./RequestHistories.vue?vue&type=script&lang=js"
export * from "./RequestHistories.vue?vue&type=script&lang=js"
import style0 from "@/assets/scss/pages/request/request-histories.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports